export const agreementStatus = {
  'need_approval': 'Требует согласования',
  'sent_for_revision': 'Отправлено на доработку',
  'agreed': 'Согласовано',
  'sent_for_signing': 'Отправлен на подписание',
  'signed': 'Подписан'
}

